export const SCHEDULE_PREFERENCE_KEYS: Record<string, string> = {
    team: "scheduleTeam",
    template: "scheduleTemplate",
    profile: "scheduleTemplate",
    home: "mySchedule",
    "my-profile": "mySchedule"
};

// One-shot notification deep-link params, never persisted with the schedule filters
export const SCHEDULE_TRANSIENT_PARAMS = ["requests", "request"];
